<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
        lineData: [
          18092,
          20728,
          24045,
          28348,
          44715,
          48444,
          50415,
          56061,
          32808,
          36097,
          39867,
          62677
        ],
        barData: [
          4600,
          5000,
          5500,
          6500,
          12500,
          14000,
          21500,
          23200,
          24450,
          7500,
          8500,
          9900
        ],
        rateData: []
      },
      data: [
        {
          lineData: [
            18092,
            20728,
            24045,
            28348,
            44715,
            48444,
            50415,
            56061,
            32808,
            36097,
            39867,
            62677
          ],
          barData: [
            4600,
            5000,
            5500,
            6500,
            12500,
            14000,
            21500,
            23200,
            24450,
            7500,
            8500,
            9900
          ]
        },
        {
          lineData: [
            18092,
            20728,
            24045,
            62677,
            28348,
            44715,
            48444,
            36097,
            39867,
            50415,
            56061,
            32808
          ],
          barData: [
            3600,
            5500,
            12500,
            6500,
            23200,
            9900,
            14450,
            15000,
            15500,
            7500,
            14000,
            21500,
          ]
        },
        {
          lineData: [
            32808,
            44715,
            48444,
            62677,
            20728,
            28092,
            50415,
            56061,
            36097,
            39867,
            28348,
            24045,
          ],
          barData: [
            6600,
            6500,
            12500,
            7500,
            8500,
            7900,
            14000,
            15000,
            5500,
            21500,
            23200,
            24450,
          ]
        },
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'power 左中'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData = this.data[index].lineData
      this.cdata.barData = this.data[index].barData

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>